import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MfaCodeService } from '../services/mfa-code.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mfa-codes',
  templateUrl: './mfa-codes.component.html',
  styleUrls: ['./mfa-codes.component.scss'],
})
export class MfaCodesComponent implements OnInit {
  form: FormGroup;
  codes: any[] = [];
  loading = false;
  errorMessage = '';
  pagination: any = null;

  constructor(
    private fb: FormBuilder,
    private mfaCodeService: MfaCodeService,
    private authService: AuthService,
    private router: Router
  ) {
    this.form = this.fb.group({
      email: [''],
      context: ['athlete'],
      verified: ['false'],
      expired: ['false'],
    });
  }

  ngOnInit(): void {
    this.search();
  }

  search(): void {
    this.loading = true;
    this.errorMessage = '';

    const params = this.form.value;
    this.mfaCodeService.search(params).subscribe({
      next: (response) => {
        this.codes = response.data?.data || [];
        this.pagination = response.data;
        this.loading = false;
      },
      error: (error) => {
        this.errorMessage = error.error?.message || 'Erro ao buscar códigos MFA';
        this.loading = false;
      },
    });
  }

  resetFilters(): void {
    this.form.reset({
      email: '',
      context: 'athlete',
      verified: 'false',
      expired: 'false',
    });
    this.search();
  }

  logout(): void {
    this.authService.logout();
  }

  formatDate(date: string | null): string {
    if (!date) return '-';
    return new Date(date).toLocaleString('pt-BR');
  }

  isExpired(expiresAt: string | null): boolean {
    if (!expiresAt) return false;
    return new Date(expiresAt) < new Date();
  }

  isVerified(verifiedAt: string | null): boolean {
    return verifiedAt !== null;
  }

  getStatusClass(code: any): string {
    if (this.isVerified(code.verified_at)) {
      return 'status-verified';
    }
    if (this.isExpired(code.expires_at)) {
      return 'status-expired';
    }
    return 'status-pending';
  }

  getStatusText(code: any): string {
    if (this.isVerified(code.verified_at)) {
      return 'Verificado';
    }
    if (this.isExpired(code.expires_at)) {
      return 'Expirado';
    }
    return 'Pendente';
  }
}

